import React from 'react';
import { Notification } from 'is24-corecss';
import StatusSkeleton from '../itemskeleton/StatusSkeleton';
import { useAppSelector } from '../../store/store';
export var MainHeading = function MainHeading(_ref) {
  var totalNumberOfAgents = _ref.totalNumberOfAgents,
    term = _ref.term;
  return /*#__PURE__*/React.createElement("h1", {
    className: "margin-none font-heading-xsmall-bold searchHeadline"
  }, "Es wurde", totalNumberOfAgents && totalNumberOfAgents > 1 ? 'n' : '', " ", totalNumberOfAgents || 'keine', ' ', "Immobilienmakler in ", term, " gefunden.");
};
var SearchSummary = function SearchSummary() {
  var term = useAppSelector(function (state) {
    var _state$gacOverAllInfo;
    return (_state$gacOverAllInfo = state.gacOverAllInfo) === null || _state$gacOverAllInfo === void 0 || (_state$gacOverAllInfo = _state$gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo === void 0 ? void 0 : _state$gacOverAllInfo.seoLabel;
  });
  var searchFailed = useAppSelector(function (state) {
    return state.search.searchFailed;
  });
  var searchInProgress = useAppSelector(function (state) {
    return state.search.searchInProgress || false;
  });
  var totalNumberOfAgents = useAppSelector(function (state) {
    return state.search.totalNumberOfAgents;
  });
  if (searchInProgress) {
    return /*#__PURE__*/React.createElement(StatusSkeleton, null);
  }
  if (searchFailed) {
    return /*#__PURE__*/React.createElement(Notification, {
      className: "margin-l",
      "data-testid": "status-error",
      title: "Es ist ein Fehler aufgetreten.",
      message: "Bitte versuchen Sie es sp\xE4ter noch einmal.",
      type: "error",
      variant: "elevated"
    });
  }
  if (!term || term.trim().length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, term && /*#__PURE__*/React.createElement("div", {
    className: "grid grid-flex grid-justify-space-between grid-align-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-item summaryContent"
  }, /*#__PURE__*/React.createElement(MainHeading, {
    totalNumberOfAgents: totalNumberOfAgents,
    term: term
  }))));
};
export default SearchSummary;